import { useFormState } from 'react-final-form';

import { WorkloadDetailsFormModel } from '../../../_types';
import { WorkloadVpaFormSettings } from '../_constants';

const isDefaultFormModelSettings: Record<
  WorkloadVpaFormSettings,
  (formModel: WorkloadDetailsFormModel) => boolean
> = {
  optimizedResources: (formModel) =>
    !formModel.verticalRightsizing.policy.optimizedResources.isOverridden,
  excludedContainers: (formModel) =>
    !formModel.verticalRightsizing.policy.excludedContainers.isOverridden,
  customMetrics: (formModel) =>
    !formModel.verticalRightsizing.policy.customMetrics.some(
      (v) => v.isOverridden
    ),
  autoscaler: (formModel) =>
    !formModel.verticalRightsizing.policy.applyType.isOverridden &&
    !formModel.verticalRightsizing.policy.rolloutBehavior.isOverridden &&
    !formModel.verticalRightsizing.policy.optimizationThreshold.isOverridden &&
    !formModel.verticalRightsizing.policy.downscaling.isOverridden &&
    !formModel.verticalRightsizing.policy.antiAffinity.isOverridden,
  overhead: (formModel) =>
    !formModel.verticalRightsizing.policy.overhead.isOverridden,
  memoryGrowthDetection: (formModel) =>
    !formModel.verticalRightsizing.policy.memoryGrowthDetection.isOverridden,
  stallDetection: (formModel) =>
    !formModel.verticalRightsizing.policy.stallDetection.isOverridden,
  recommendationPercentile: (formModel) =>
    !formModel.verticalRightsizing.policy.recommendationPercentile.isOverridden,
  workloadResourceLimits: (formModel) =>
    !formModel.verticalRightsizing.policy.resourceLimits.isOverridden,
  workloadConstraints: (formModel) =>
    !formModel.verticalRightsizing.policy.workloadConstraints.some(
      (v) => v.isOverridden
    ),
  lookbackPeriod: (formModel) =>
    !formModel.verticalRightsizing.policy.lookbackPeriod.isOverridden,
  startupMetrics: (formModel) =>
    !formModel.verticalRightsizing.policy.startupMetrics.isOverridden,
  hpaConverter: (formModel) =>
    !formModel.verticalRightsizing.policy.hpaConverter.isOverridden,
  predictiveScaling: (formModel) =>
    !formModel.verticalRightsizing.policy.predictiveScaling.isOverridden,
};

export const useVpaSettingIsDefault = (
  settingName: WorkloadVpaFormSettings
) => {
  const form = useFormState<WorkloadDetailsFormModel>({
    subscription: { values: true },
  });

  return isDefaultFormModelSettings[settingName](form.values);
};
